import "./Suggestions.scss";

const Suggestions = ({ handleSuggestion, suggestions }) => {
  // handles
  const handleKeyDown = (event) => {
    if (event.keyCode === 13) handleMouseDown(event);
  };

  const handleMouseDown = (event) => {
    handleSuggestion(event.currentTarget.id);
  };

  return (
    <div className="cmp-product-finder-suggestions">
      <ul className="cmp-product-finder-suggestions__dropdown" role="list-box">
        {suggestions.map((suggestion) => (
          <li
            className="cmp-product-finder-suggestions__suggestion"
            id={suggestion}
            onKeyDown={handleKeyDown}
            onMouseDown={handleMouseDown}
            role="option"
            tabIndex="0"
          >
            {suggestion}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Suggestions;
